
export const screenSmall = '36rem'
export const screenMedium = '47rem'
export const screenLarge = '64rem'
export const screenXLarge = '72rem'
export const screenXXLarge = '90rem'

// Header/Footer breakpoints, used in main page template
// so that the responsive behaviour is consistent with 
// the header/footer breakpoints
export const navScreenMedium = '48rem'
